import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BRANDS, COMPANY } from "@/config/site";

// Parent → eight brands structure diagram.
export const BrandStructure = () => {
  const [active, setActive] = useState(null);
  return (
    <div className="relative" data-testid="brand-structure">
      <div className="flex flex-col items-center">
        <div className="flex items-center gap-3 rounded-full border hairline bg-white px-5 py-3 shadow-[0_1px_0_rgba(20,22,27,0.04)]">
          <img src={COMPANY.mark} alt="" className="h-7 w-auto" />
          <span className="text-sm font-semibold">{COMPANY.name}</span>
        </div>
        <motion.span
          className="block w-px bg-ink/30 origin-top"
          initial={{ scaleY: 0 }}
          whileInView={{ scaleY: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          style={{ height: 40 }}
        />
      </div>
      <motion.div
        className="h-px w-full bg-ink/30 origin-center"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
      />
      <ul className="grid grid-cols-2 sm:grid-cols-4">
        {BRANDS.map((b, i) => (
          <motion.li
            key={b.id}
            className="relative flex flex-col items-center px-1 pt-6"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.6 + i * 0.06, duration: 0.6 }}
          >
            <span className="absolute top-0 h-6 w-px bg-ink/30" />
            <Link
              to={`/brands#${b.id}`}
              onMouseEnter={() => setActive(b.id)}
              onMouseLeave={() => setActive(null)}
              onFocus={() => setActive(b.id)}
              onBlur={() => setActive(null)}
              className={`mb-3 flex w-full flex-col items-center rounded border px-2 py-4 text-center transition-[background-color,border-color,transform] duration-300 ${
                active === b.id ? "-translate-y-1 border-[var(--ink)] bg-white" : "hairline bg-[var(--paper)]"
              }`}
              data-testid={`structure-node-${b.id}`}
            >
              <span className="font-display text-[1.05rem] leading-tight">{b.name}</span>
              <span className="mt-1.5 font-mono-label text-[0.62rem] uppercase leading-snug tracking-[0.12em] text-[var(--ink-2)]">{b.category}</span>
            </Link>
          </motion.li>
        ))}
      </ul>
    </div>
  );
};
